import React from "react";
import FormationBookmarksPage from "./FormationBookmarksPage";

export default function BookmarksManager() {
    return <FormationBookmarksPage role="manager" />;
}
